import React from "react";
import YesNoDialog from "components/common/dialogBox/YesNoDialog";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { DOCUMENT_HEADER_QUERY } from "../../queries/insuranceDocumentQueries";

const DuplicationDialogContainer = ({ onCloseConfirmationDialog, onConfirmDialog, documentId }) => {
  const { t } = useTranslation();

  const { loading, data } = useQueryWithSimpleErrorHandling(DOCUMENT_HEADER_QUERY, {
    variables: { documentId },
    fetchPolicy: "network-only"
  });

  return (
    !loading && (
      <YesNoDialog
        title={t("Offer.Duplication.Title")}
        content={t("Offer.Duplication.Description", {
          documentNumber: data?.documentHeader?.documentNumber,
          clientName: data?.documentHeader?.clientName || "-"
        })}
        open={true}
        onClose={onCloseConfirmationDialog}
        onConfirm={onConfirmDialog}
      />
    )
  );
};

DuplicationDialogContainer.propTypes = {
  onCloseConfirmationDialog: PropTypes.func.isRequired,
  onConfirmDialog: PropTypes.func.isRequired,
  documentId: PropTypes.number.isRequired
};

export default DuplicationDialogContainer;
